export default function Products() {
  const products = [
    {
      name: 'VPN Shield',
      description: 'Secure your connection with military-grade encryption',
      image: 'https://public.readdy.ai/ai/img_res/94ba71a113239a8a276b1ddcf6feadbc.jpg'
    },
    {
      name: 'Smart Cleaner',
      description: 'Optimize device performance and free up storage space',
      image: 'https://readdy.ai/api/search-image?query=minimalist%20phone%20cleaning%20icon%20illustration%20on%20clean%20white%20background%2C%20modern%20iOS%20app%20interface%20design%2C%20simple%20geometric%20shapes%2C%20broom%20or%20sparkle%20symbol%2C%20gradient%20green%20and%20teal%20colors%2C%20professional%20mobile%20app%20mockup%2C%20clean%20minimal%20aesthetic%2C%20soft%20shadows&width=280&height=200&seq=prod-clean-001&orientation=landscape'
    },
    {
      name: 'Privacy Guard',
      description: 'Protect your personal data and browsing activity',
      image: 'https://readdy.ai/api/search-image?query=minimalist%20privacy%20shield%20icon%20illustration%20on%20clean%20white%20background%2C%20modern%20iOS%20app%20interface%20design%2C%20simple%20geometric%20shapes%2C%20eye%20with%20shield%20symbol%2C%20gradient%20purple%20and%20pink%20colors%2C%20professional%20mobile%20app%20mockup%2C%20clean%20minimal%20aesthetic%2C%20soft%20shadows&width=280&height=200&seq=prod-priv-001&orientation=landscape'
    },
    {
      name: 'Speed Booster',
      description: 'Enhance device speed and app performance',
      image: 'https://readdy.ai/api/search-image?query=minimalist%20speed%20rocket%20icon%20illustration%20on%20clean%20white%20background%2C%20modern%20iOS%20app%20interface%20design%2C%20simple%20geometric%20shapes%2C%20lightning%20bolt%20symbol%2C%20gradient%20orange%20and%20yellow%20colors%2C%20professional%20mobile%20app%20mockup%2C%20clean%20minimal%20aesthetic%2C%20soft%20shadows&width=280&height=200&seq=prod-speed-001&orientation=landscape'
    }
  ];

  return (
    <section id="products" className="relative py-32 px-12 bg-zinc-900">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-start justify-between mb-16">
          <div className="inline-block px-6 py-2 rounded-full border border-white/20">
            <span className="text-sm text-white font-light tracking-wide">Our Products</span>
          </div>
          
          <div className="text-right">
            <h2 className="text-6xl font-extrabold text-white leading-tight">
              VPN & Cleaner
              <br />
              <span className="text-5xl">Applications</span>
            </h2>
          </div>
        </div>

        <div className="flex gap-8 overflow-x-auto pb-8 scrollbar-hide">
          {products.map((product, index) => (
            <div key={index} className="flex-shrink-0 w-72">
              <div className="bg-stone-100 rounded-2xl overflow-hidden h-52">
                <img 
                  src={product.image}
                  alt={product.name}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="mt-6">
                <h3 className="text-2xl font-bold text-white mb-2">{product.name}</h3>
                <p className="text-base text-gray-400 font-light leading-relaxed">{product.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}